import React from "react";

// components
import { SelectFilter } from "../_commons/SelectFilter";
import { SearchFilter } from "../_commons/SearchFilter";

export const Header = (props) => {
	return (
		<div className="filters">
			<div className="filter-buttons">
				<SelectFilter
					options={[
						{ value: true, valueForDisplay: "Active" },
						{ value: false, valueForDisplay: "Archived" }
					]}
					field="is_active"
					currValue={{
						...props.appliedFilters?.is_active,
						valueForDisplay: (
							<span
								style={{
									color: !props.appliedFilters?.is_active?.value ? "#FF425C" : "#363636",
									fontWeight: "600"
								}}
							>
								<span style={{ color: "#8A8A8A", fontWeight: "400" }}>Status: </span>
								{props.appliedFilters?.is_active?.valueForDisplay}
							</span>
						)
					}}
					labelKey="valueForDisplay"
					valueKey="value"
					setFilter={props.handleFilters}
					isSearchable={false}
					isClearable={false}
				/>
				{props.dimensions.width > 768 && (
					<SelectFilter
						options={[
							{ valueForDisplay: "All Roles", value: "" },
							...(props?.filters?.find((filter) => filter.field === "roles")?.values ?? [])
						]}
						field="roles"
						currValue={props.appliedFilters?.roles || null}
						setFilter={props.handleFilters}
						labelKey="valueForDisplay"
						valueKey="value"
						isClearable={false}
						isSearchable={true}
						placeholder="Select Roles"
					/>
				)}
			</div>
			{props.searchKeywords && props.searchKeywords.length > 1
				? props.dimensions.width > 768 && (
						<div className="search-input-container">
							<SelectFilter
								options={props.searchKeywords}
								field="searchFieldSelected"
								currValue={props.searchFieldSelected}
								setFilter={props.handleSearchField}
								labelKey="valueForDisplay"
								valueKey="key"
								isSearchable={false}
								isClearable={false}
							/>
							<SearchFilter
								filterOption={{ field: "searchFieldValue" }}
								value={props.searchFieldValue}
								setFilter={props.setFilter}
								placeholder="Search"
							/>
						</div>
					)
				: props.dimensions.width > 768 && (
						<SearchFilter
							filterOption={{ field: "searchFieldValue" }}
							value={props.searchFieldValue}
							setFilter={props.setFilter}
							placeholder="Search"
						/>
					)}
		</div>
	);
};
